import {
  formatCurrency,
  getSinglarOrPluralWord,
} from "../../../../utilities/helpers";

import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";

export default function InfoCard({
  paymentPlans,
  installmentMonths,
  total,
  children,
}) {
  return (
    <Card body className="card--xs info-card card-with-border">
      <Card.Text className="info-text info-text-md">{children}</Card.Text>
      {paymentPlans && Object.keys(paymentPlans)?.length > 0 && (
        <ul className="mt-3">
          <li className="list list-sm list-item list-item--vertical list-item-lg list-item-lg--sm">
            <Stack as="ul" gap={1}>
              <Stack as="li" direction="horizontal" className="split-row">
                <span>Due now:</span>
                <span>{formatCurrency(paymentPlans[1]?.amount)}</span>
              </Stack>
              <Stack as="li" direction="horizontal" className="split-row">
                <span>Future payments:</span>
                <span>
                  {installmentMonths - 1}{" "}
                  {getSinglarOrPluralWord(
                    installmentMonths - 1,
                    "month",
                  ).toLowerCase()}{" "}
                  x {formatCurrency(paymentPlans[2]?.amount)}
                </span>
              </Stack>
            </Stack>
            <Stack
              as="li"
              direction="horizontal"
              className="split-row seperator seperator-xs"
            >
              <span className="small small-bold ">Total</span>
              <span className="small small-bold ">{formatCurrency(total)}</span>
            </Stack>
          </li>
        </ul>
      )}
    </Card>
  );
}
